export default [
  {
    path: '/real-estate-developments/:id/units/new',
    name: 'RealEstateDevelopmentsUnitsCreate',
    component: () => import('pages/real-estate-developments/tabs/units/form/tabs/UnitsForm.vue')
  },
  {
    path: '/real-estate-developments/:parentId/units/:id',
    component: () => import('pages/real-estate-developments/tabs/units/form/_layouts/UnitsFormLayout.vue'),
    children: [
      {
        path: 'edit',
        name: 'RealEstateDevelopmentsUnitsEdit',
        component: () => import('pages/real-estate-developments/tabs/units/form/tabs/UnitsForm.vue')
      },
      {
        path: 'prices/edit',
        name: 'RealEstateDevelopmentsUnitsPricesEdit',
        component: () => import('pages/real-estate-developments/tabs/units/form/tabs/UnitsPricesForm.vue')
      }
    ]
  }
]
